import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import GeneralCountryComponent from "./GeneralCountryComponent";
import PortugalIntroSection from "../../components/tours/portugal/PortugalIntroSection";
import PortugalTripInformationSection from "../../components/tours/portugal/PortugalTripInformationSection";
import PortugalImagesSection from "../../components/tours/portugal/PortugalImagesSection";
import PortugalTripDetailsSection from "../../components/tours/portugal/PortugalTripDetailsSection";


const Portugal = () => {
    return (
        <GeneralCountryComponent title={'portugal'}>
            <PortugalIntroSection/>
            <PortugalTripInformationSection/>
            <PortugalImagesSection/>
            <PortugalTripDetailsSection/>
        </GeneralCountryComponent>
    );
}

export default Portugal;
